<template>
  <div>
      <!-- {{store[0]['title']}}
      <br>
      {{store[0]['content']}} -->
<div class="container" v-if="datagot" id="newspage">
  <div class="row bar">
        <div class="col-12 col-md-5">
          <div class="d-flex justify-content-between mb-1">
            <div class="col-auto bg-n-red">最新消息</div>
            <div class="col bg-n-gray text-left">NEWS</div>

          </div>
        </div>
       
      </div>
  <div class="row text-left title-mb" >
        <div class="col-12 col-md-8  top-title "> {{store[0]['title']}}</div>
        <div class="w-100 d-md-none"></div>
        <div class="col date text-right">{{store[0]['created_date']}}</div>
  </div>
  <!-- <h1 class="text-center title">{{store[0]['title']}}</h1> -->
  <p class="text-left content" v-html="store[0]['content']" ></p>
</div>
      
  </div>
</template>


<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
export default {

  data(){
    return{
      datagot:false,
      page:0,
      store:[],
      a: [
        {
          xs: "/static/news/320/1.jpg",
          sm: "/static/news/320/1.jpg",
          md: "/static/news/768/1.jpg",
          lg: "/static/news/768/1.jpg",
          xl: "/static/news/1200/1.jpg"
        }
      ]
    }
  },
  methods: {
    pusha() {
      let vm = this;
      vm.$emit("pusha", vm.a);
    },
    getUrl() {
      let vm = this;
      let url = document.URL;
      console.log(url);
      let sliceposition = url.lastIndexOf("/");
      console.log(sliceposition);
      let slicedata = url.slice(sliceposition + 1);
      console.log(slicedata);
      vm.page = parseInt(slicedata);
      console.log("url給的>>" + vm.page);
      vm.getData();
    },
    getData() {
      let vm = this;

      axios({
        method: "post",
        url: "https://iled.com.tw/bridging/api/v1/news/content",
        params: {
          id: vm.page,
          
        }
      })
        .then(function(response) {
          console.log(response);

          vm.store = [];
          // response.data.data.forEach(element => {
          //   vm.store.push(element);
          // });
          vm.store.push(response.data.data);
          vm.datagot=true;
        })
    }
  },
  created: function() {
    this.pusha();
    this.getUrl();
  },
  mounted: function() {
    
  },
}
</script>

<style lang="sass" scoped>
@import "~bootstrap/scss/bootstrap"
.red-div
  width: 50px
  height: 50px
  background-color: rgb(175, 40, 45)
.gray-div
  color: white
  line-height: 50px
  width: 130px
  height: 50px
  background-color: rgb(205, 205, 205)
.clamp-1
  overflow: hidden
  text-overflow: ellipsis
  display: -webkit-box
  -webkit-line-clamp: 1
  /*! autoprefixer: off */
  -webkit-box-orient: vertical
  /* autoprefixer: on */
.top-title
  font-weight: bold
  line-height: 50px
  font-size: 28px
  color: rgb(51, 58, 64)
.date
  line-height: 50px
  color: rgb(51, 58, 64)
  font-size: 24px

.title
  font-size: 27px
  margin-top: 55px
  margin-bottom: 55px
.content
  font-size: 16px
  margin-bottom: 55px

// .bg-n-red
//   background-color: rgb(182, 40 ,44)
//   color: white
//   text-align: center
//   padding-top: 7px
//   padding-bottom: 7px
// .bg-n-gray
//   background-color: rgb(51, 58, 64)
//   color: white
//   padding-left: 13px
//   padding-top: 7px
//   padding-bottom: 7px
#newspage
  @include media-breakpoint-up(xl)
    padding-top: 118px
    padding-bottom:  212px
  @include media-breakpoint-up(xs)
    padding-top: 46px
    padding-bottom:  146px
.title-mb
  margin-bottom: 35px
.bar
  @include media-breakpoint-up(xl)
    margin-bottom: 50px
  @include media-breakpoint-up(xl)
    margin-bottom: 16px
.bg-n-red
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(182, 40 ,44)
  color: white
  text-align: center
  padding-top: 7px
  padding-bottom: 7px
.bg-n-gray
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(51, 58, 64)
  color: white
  padding-left: 13px
  padding-top: 7px
  padding-bottom: 7px
</style>




// WEBPACK FOOTER //
// src/components/NewsPage.vue